import { EnvironmentInjector, inject, runInInjectionContext } from '@angular/core';
import type { CanActivateFn, CanMatchFn, GuardResult, MaybeAsync } from '@angular/router';

type AnyGuard = (...args: unknown[]) => MaybeAsync<GuardResult>;

/**
 * Lets only super-admins into user management. Loads the admin feature lib's guard on first
 * use, so the eager bundle doesn't pull in the whole admin lib just for a role check.
 */
export const lazySuperAdminGuard = ((...args: unknown[]) => {
  const injector = inject(EnvironmentInjector);
  return import('@echospaces-web-monorepo/es-portal-admin').then(({ superAdminGuard }) =>
    runInInjectionContext(injector, () => (superAdminGuard as AnyGuard)(...args)));
}) as CanActivateFn & CanMatchFn;
